import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListActivities } from "../../../components/Admin/Activities";
import { useLanguage } from "../../../contexts";
import "./Activities.scss";

export function Activities() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_activities"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListActivities activitiesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_activities"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListActivities activitiesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="activities-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="activities-page-header-wrapper">
        <div className="activities-page-header">
          <span className="activities-page-title">{translations.activities}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
